<ng-container *ngIf="!downloadButtons">
    <mat-card>
        <mat-card-content class="newOrder">
            <div class="titleHead">
                <div class="titleLeft">
                    <title-back [addTitle]="true" [Title]="'Report List'" (back)="closeDetails()"></title-back>
                </div>
                <div class="tableFilter reportTableFilter">
                    <mat-form-field appearance="outline" fxFlex="14em">
                        <input matInput [ngModel]="searchTerm" (ngModelChange)="applyFilter($event)"
                               placeholder="Search">
                        <i class="flaticon-search" matSuffix></i>
                    </mat-form-field>
                    <button mat-raised-button class="addBtn sleekBtn" (click)="openSidePanel()">Request New Report
                    </button>
                </div>
            </div>
            <logzy-table-loader *ngIf="loading"></logzy-table-loader>
            <div class="setTable" *ngIf="!loading">
                <ng-container *ngIf="reportList?.data.length">
                    <mat-table [dataSource]="reportList" matSort (matSortChange)="announceSortChange($event)">

                        <ng-container [matColumnDef]="'name'">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>Report Name</mat-header-cell>
                            <mat-cell *matCellDef="let data" class="fs-12">
                                <span>{{data.name}}</span>
                            </mat-cell>
                        </ng-container>

                        <ng-container [matColumnDef]="'description'">
                            <mat-header-cell *matHeaderCellDef>Description</mat-header-cell>
                            <mat-cell *matCellDef="let data" class="fs-12 ">
                                <span>{{data.description}}</span>
                            </mat-cell>
                        </ng-container>

                        <ng-container [matColumnDef]="'actions'">
                            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                            <mat-cell *matCellDef="let data" class="fs-12 ">
                                <div class="action">
                                    <i class="flaticon-share" [matTooltip]="'Share on Email'" matTooltipPosition="above"
                                       (click)="openSendEmailConfirmationDialog(data)"></i>
                                    <i class="flaticon-download" [matTooltip]="'Download'" matTooltipPosition="below"
                                       (click)="downloadPageReport(data)"></i>
                                    <i class="flaticon-view" [matTooltip]="'Access Logs'" matTooltipPosition="below"
                                       (click)="viewLogs(data)"></i>
                                </div>
                            </mat-cell>
                        </ng-container>
                        <mat-header-row class="header-row" *matHeaderRowDef="displayColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayColumns;"
                                 [class.blur]="updateReportList"></mat-row>
                    </mat-table>
                    <div class="loadingData" [class.d-none]="!updateReportList">
                        <logzy-gear-loader></logzy-gear-loader>

                    </div>
                    <mat-paginator [pageSizeOptions]="[5, 10, 25]" aria-label="Select page of users" [pageSize]="10"
                                   [length]="pageLength" (page)="pageChanged($event)"></mat-paginator>

                    <!-- <ng-container *ngIf="!leadList?.data.length">
            <div class="noData" (mousemove)="onMouseMove($event)">
                <h1 #title>No Data Found</h1>
            </div>
        </ng-container> -->
                </ng-container>
                <ng-container *ngIf="!reportList?.data.length">
                    <logzy-billu part1="No " part2="Data " part3="here." font="14px"></logzy-billu>
                </ng-container>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>

<ng-container *ngIf="downloadButtons && reportListForPage.length > 0">
    <button class="Save downloadReport" mat-stroked-button [matMenuTriggerFor]="downloadReport"><i
            class="flaticon-download"></i> Reports
    </button>
    <button class="Save smallDownloadReport" mat-icon-button [matMenuTriggerFor]="downloadReport"><i
            class="flaticon-download"></i></button>
    <mat-menu #downloadReport="matMenu" xPosition="before">
        <ng-container *ngFor="let report of reportListForPage">
            <button mat-menu-item (click)="downloadPageReport(report)">{{report.name}}</button>
        </ng-container>
    </mat-menu>
</ng-container>